import { Component, OnInit } from '@angular/core';
import { AppComponent } from 'src/app/app.component';
import { Routes, RouterModule, Router, NavigationEnd } from '@angular/router';
import { ToursService } from '../../Services/tours.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-event-details',
  templateUrl: './event-details.component.html',
  styleUrls: ['./event-details.component.scss', '../../../assets/css/circle.css']
})
export class EventDetailsComponent implements OnInit {

  constructor(public appComponent: AppComponent, private router: Router, private route: ActivatedRoute, private toursService: ToursService, private sanitizer: DomSanitizer) { }

  eventseoname: any;
  isLoading: boolean = false;
  eventdetaildata: any;
  isSoldout: boolean = false;
  index: any = 0;
  nationalfinalslist: any = [];
  latitude: any;
  longitude: any;
  latlong: any = [];
  isEventStarted: boolean = false;
  isEventRegisterEnded: boolean = false;
  isDirector: boolean = false;
  isEventEnd: boolean = false;
  isEventListingNotes: boolean = false;
  postEventDetail = {
    ResultUrl: "",
    PhotoUrlList: [],
    EventTypeName: ""
  };
  videourllist: any = [];
  virtualdocurl: any;
  Listingtext: any;
  preEventDetail = {
    GeneralScheduleUrl: null,
    VenueList: [],
    ListingNotesNumber: 0,
    Extension: "",
    SalesEmail: "",
    StartEndDate: "",
    City: "",
    State: "",
    EventRepImageUrl: "",
    FirstName: "",
    LastName: "",
    RegistrationDeadline: "",
    HotelList: [],
    FacultyList: [],
    DirectorList: [],
    EventTypeName: "",
    EventId: 0,
    ParentPacketUrl: "",
    LivestreamUrls: []
  };
  faculty: any;
  mapStyles: any[] = [
    {
      elementType: 'geometry',
      stylers: [{ color: '#4D4D4F' }] // Background color
    },
    {
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#242f3e' }]
    },
    {
      elementType: 'labels.text.fill',
      stylers: [{ color: '#746855' }]
    },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#263c3f' }]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6b9a76' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#38414e' }]
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#212a37' }]
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9ca5b3' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#746855' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1f2835' }]
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#f3d19c' }]
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#2f3948' }]
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }]
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#17263c' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#515c6d' }]
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#17263c' }]
    }
  ];
  LiveStreamURL = []
  ngOnInit() {
    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }
      window.scrollTo(0, 0)
    });
    this.route.paramMap.subscribe(params => {
      this.eventseoname = params.get('eventseoname');
    });

    this.getEventdetail(this.eventseoname);
  }

  getEventdetail(eventseoname) {
    this.isLoading = true;
    this.toursService.GetEventDetail(eventseoname).subscribe(evntdetail => {
      this.isLoading = false;
      if (evntdetail != null) {
        this.eventdetaildata = evntdetail;
        this.isEventEnd = this.eventdetaildata.Response.Data.EventDetail.IsEventEnd;
        if (this.eventdetaildata.Response.Data.EventDetail.PreEventDetail != null && this.isEventEnd == false) {
          this.preEventDetail = this.eventdetaildata.Response.Data.EventDetail.PreEventDetail;
          if (this.eventdetaildata.Response.Data.EventDetail.PreEventDetail.ListingNotes != "") {
            this.isEventListingNotes = true;
            this.Listingtext = this.sanitizer.bypassSecurityTrustHtml(this.eventdetaildata.Response.Data.EventDetail.PreEventDetail.ListingNotes);
          }
          this.nationalfinalslist = this.eventdetaildata.Response.Data.NationalImagelist;
          this.isSoldout = this.eventdetaildata.Response.Data.EventDetail.IsSoldout;
          this.isEventStarted = this.eventdetaildata.Response.Data.EventDetail.IsEventStarted;
          this.isEventRegisterEnded = this.eventdetaildata.Response.Data.EventDetail.IsEventRegisterEnded;
          this.eventdetaildata.Response.Data.EventDetail.PreEventDetail.VenueList.forEach(childObj => {
            this.latlong = childObj.LatLong.split(",");
            this.latitude = parseFloat(this.latlong[0]);
            this.longitude = parseFloat(this.latlong[1]);
          })
          this.eventdetaildata.Response.Data.EventDetail.PreEventDetail.DirectorList.forEach(childObj => {
            if (childObj.Roles.includes('Director') || childObj.Roles.includes('Opening Number Choreographer')) {
              this.isDirector = true;
            }
          })

          this.preEventDetail.LivestreamUrls.forEach(childObj => {
            var tmpObj = this.sanitizer.bypassSecurityTrustResourceUrl(childObj);
            this.LiveStreamURL.push(tmpObj);
          })

        }
        else {
          this.postEventDetail = this.eventdetaildata.Response.Data.EventDetail.PostEventDetail;
          this.nationalfinalslist = this.eventdetaildata.Response.Data.NationalImagelist;
          this.eventdetaildata.Response.Data.EventDetail.PostEventDetail.VideoUrlList.forEach(childObj => {
            childObj = this.sanitizer.bypassSecurityTrustResourceUrl(childObj);
            this.videourllist.push(childObj);
          })
        }
      }
    }, err => {
      console.log('err in tour date detail - Pre event component', err);
      this.isLoading = false;
    });
  }


  onNavigate(type, data) {
    if (type == "Detail") {
      setTimeout(() => {
        this.router.navigate(['/faculty-detail', data]);
      }, 5);
    }
    else if (type == "eventdetails") {
      setTimeout(() => {
        this.router.navigate(['/event-details', data]);
      }, 5);
    } 
  }
}
